import { useState } from "react";

function usePassword() {
    const [showPassword, setshowPassword] = useState(false)
    const [showOldPassword, setShowOldPassword] = useState(false)

    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    const handleShowPassword = () => {
        setshowPassword(true)
    }
    const handleHidePassword = () => {
        setshowPassword(false)
    }
    const handleShowConfirmPassword = () => {
        setShowConfirmPassword(true)
    }
    const handleHideConfirmPassword = () => {
        setShowConfirmPassword(false)
    }
    const handleShowOldPassword = () => {
        setShowOldPassword(true)
    }
    const handleHideOldPassword = () => {
        setShowOldPassword(false)
    }


  return {showPassword, handleShowPassword, showConfirmPassword, handleHidePassword, showOldPassword, handleShowConfirmPassword, handleHideConfirmPassword, handleHideOldPassword, handleShowOldPassword}
}

export default usePassword